import { FC } from "react";

interface InformFeaturesProps {
    features: any[] | undefined | null;
    label: string;
}

export const InformFeatures: FC<InformFeaturesProps> = ({
    features,
    label,
}) => {
    const filterValidFeatures = (
        features: any[] | undefined | null
    ): string[] => {
        return (
            features
                ?.map((feature) => feature?.value?.Name)
                .filter(
                    (name) =>
                        name !== undefined &&
                        name !== null &&
                        name.trim() !== "" // Exclude empty strings
                ) || []
        );
    };

    const validFeatures = filterValidFeatures(features);

    if (validFeatures.length === 0) {
        return null; // Do not render if no valid features
    }

    return (
        <div className="comparison-card">
            <div className="comparison-card__title">{label}</div>
            <div className="comparison-feature">
                <div className="list_tag">
                    {validFeatures.map((feature, index) => (
                        <span key={index} className="tag">
                            {feature}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};
